export const capitalizeFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const capitalizeFirstLetterOfTheWord = (text: string): string => {
  const sentenceArr: string[] = [];
  text.split(' ').forEach((word: string) => {
    sentenceArr.push(capitalizeFirstLetter(word));
  });
  return sentenceArr.join(' ');
};

export const encurtarTexto = (str: string, num: number) => {
  if (str.length > num) {
    return str.slice(0, num) + "...";
  } else {
    return str;
  }
}
